import Shake from 'react-reveal/HeadShake';

export default function FormAlertDanger({...props}) {
  return (
    <Shake>
      <article className='bg-rojo-fuego border border-rojo-fuego rounded-lg p-4 mb-4' {...props}>
        <section>
          <h6 className='text-white'>{props.labelText}</h6>
          {props.content && <div className='text-white'>{props.content}</div>}
        </section>
      </article>
    </Shake>
  )
}

export function FormAlertInfo({...props}) {
  return (
    <Shake>
      <article className='bg-azul-link border border-azul-link rounded-lg p-4 mb-4' {...props}>
        <section>
          <h6 className='text-white'>{props.labelText}</h6>
          {props.content && <div className='text-white'>{props.content}</div>}
        </section>
      </article>
    </Shake>
  )
}

export function FormAlertSuccess({...props}) {
  return (
    <Shake>
      <article className='bg-verde-musgo border border-verde-musgo rounded-lg p-4 mb-4' {...props}>
        <section>
          <h6 className='text-white'>{props.labelText}</h6>
          {props.content && <div className='text-white'>{props.content}</div>}
        </section>
      </article>
    </Shake>
  )
}
